import { FC, useMemo } from 'react'

import { parseYouTubeUrl } from './helpers/parseYouTubeUrl'

type Props = { url: string; preferVerticalForShorts?: boolean }

const YouTubeEmbed: FC<Props> = ({ url, preferVerticalForShorts = true }) => {
  const { videoId, startSeconds } = useMemo(() => parseYouTubeUrl(url), [url])

  if (!videoId) return null

  const isShort = /youtube\.com\/shorts\//.test(url)
  const search = new URLSearchParams({
    enablejsapi: '1',
    playsinline: '1',
    rel: '0',
    modestbranding: '1',
    ...(startSeconds ? { start: String(startSeconds) } : {}),
  }).toString()

  const iframeSrc = `https://www.youtube.com/embed/${videoId}?${search}`

  const aspect = isShort && preferVerticalForShorts ? 9 / 16 : 16 / 9

  return (
    <div
      className="relative w-full overflow-hidden rounded-sm"
      style={{
        aspectRatio: String(aspect),
      }}
    >
      <iframe
        src={iframeSrc}
        title="YouTube player"
        className="h-full w-full"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
        loading="lazy"
      />
    </div>
  )
}

export default YouTubeEmbed
